const messages = {
  playSudokuDailyToday: {
    id: 'playSudokuDailyToday',
    defaultMessage: 'Play the Sudoku Daily today!',
  },
  playNonogramDailyToday: {
    id: 'playNonogramDailyToday',
    defaultMessage: 'Play the Nonogram Daily today!',
  },
  sudoku: {
    id: 'sudoku',
    defaultMessage: 'Sudoku',
  },
  timeRecorded: {
    id: 'timeRecorded',
    defaultMessage: 'Your time has been recorded!',
  },
  dailyNonogramFor: {
    id: 'dailyNonogramFor',
    defaultMessage: 'Daily Nonogram for ',
  },
  privacyPolicy: {
    id: 'privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  termsOfService: {
    id: 'termsOfService',
    defaultMessage: 'Terms of Service',
  },
  account: {
    id: 'account',
    defaultMessage: 'Account',
  },
  username: {
    id: 'username',
    defaultMessage: 'Username',
  },
  password: {
    id: 'password',
    defaultMessage: 'Password',
  },
  oldPassword: {
    id: 'oldPassword',
    defaultMessage: 'Old Password',
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Loading',
  },
  login: {
    id: 'login',
    defaultMessage: 'Login',
  },
  noAccount: {
    id: 'noAccount',
    defaultMessage: 'Don\'t have an account?',
  },
  createAccount: {
    id: 'createAccount',
    defaultMessage: 'Create an account',
  },
  required: {
    id: 'required',
    defaultMessage: 'Required',
  },
  loggedIn: {
    id: 'loggedIn',
    defaultMessage: 'You are logged in.',
  },
  logout: {
    id: 'logout',
    defaultMessage: 'Logout',
  },
  loggedOut: {
    id: 'loggedOut',
    defaultMessage: 'You are now logged out',
  },
  returnToPuzzles: {
    id: 'returnToPuzzles',
    defaultMessage: 'Return to Puzzles',
  },
  changePassword: {
    id: 'changePassword',
    defaultMessage: 'Change Password',
  },
  settings: {
    id: 'settings',
    defaultMessage: 'Settings',
  },
  settingsUpdated: {
    id: 'settingsUpdated',
    defaultMessage: 'Settings Updated',
  },
  register: {
    id: 'register',
    defaultMessage: 'Register',
  },
  forgotYourPassword: {
    id: 'forgotYourPassword',
    defaultMessage: 'Forgot Your Password?',
  },
  resetPassword: {
    id: 'resetPassword',
    defaultMessage: 'Reset Your Password',
  },
  email: {
    id: 'email',
    defaultMessage: 'Email',
  },
  confirmPassword: {
    id: 'confirmPassword',
    defaultMessage: 'Confirm Password',
  },
  passwordUpdated: {
    id: 'passwordUpdated',
    defaultMessage: 'Password Updated',
  },
  passwordsMustMatch: {
    id: 'passwordsMustMatch',
    defaultMessage: 'Passwords must match',
  },
  haveAnAccount: {
    id: 'haveAnAccount',
    defaultMessage: 'Already have an account?',
  },
  ajaxError: {
    id: 'ajaxError',
    defaultMessage: 'There was a problem. Try again later',
  },
  language: {
    id: 'language',
    defaultMessage: 'Language',
  },
  size: {
    id: 'size',
    defaultMessage: 'Size',
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
  },
  invalidEmail: {
    id: 'invalidEmail',
    defaultMessage: 'Provide a valid email',
  },
  sendingEmail: {
    id: 'sendingEmail',
    defaultMessage: 'Sending email',
  },
  resetEmailSent: {
    id: 'resetEmailSent',
    defaultMessage: 'Check your email for the link to reset your password.',
  },
  ad: {
    id: 'ad',
    defaultMessage: 'Advertisement',
  },
  nonogramPuzzle: {
    id: 'nonogramPuzzle',
    defaultMessage: 'Nonogram Puzzle',
  },
  goodLuck: {
    id: 'goodLuck',
    defaultMessage: 'Good Luck!',
  },
  errorFound: {
    id: 'errorFound',
    defaultMessage: 'Error Found',
  },
  correct: {
    id: 'correct',
    defaultMessage: 'Correct!',
  },
  startOver: {
    id: 'startOver',
    defaultMessage: 'Start Over',
  },
  showCorrect: {
    id: 'showCorrect',
    defaultMessage: 'Show Correct Rows/Cols',
  },
  checkIt: {
    id: 'checkIt',
    defaultMessage: 'Check It',
  },
  newNonogram: {
    id: 'newNonogram',
    defaultMessage: 'New Nonogram',
  },
  topTimesFor: {
    id: 'topTimesFor',
    defaultMessage: 'Top Times for {size}x{size}',
  },
  noTimes: {
    id: 'noTimes',
    defaultMessage: 'No times to show',
  },
  user: {
    id: 'user',
    defaultMessage: 'User',
  },
  time: {
    id: 'time',
    defaultMessage: 'Time',
  },
  puzzle: {
    id: 'puzzle',
    defaultMessage: 'Puzzle',
  },
  nonogramSizes: {
    id: 'nonogramSizes',
    defaultMessage: 'Nonogram Sizes',
  },
  contactMe: {
    id: 'contactMe',
    defaultMessage: 'Contact Me',
  },
  howToSolve: {
    id: 'howToSolve',
    defaultMessage: 'How To Solve',
  },
  topTimes: {
    id: 'topTimes',
    defaultMessage: 'Top Times',
  },
  languages: {
    id: 'languages',
    defaultMessage: 'Languages',
  },
  yourName: {
    id: 'yourName',
    defaultMessage: 'Your Name',
  },
  yourEmail: {
    id: 'yourEmail',
    defaultMessage: 'Your Email',
  },
  message: {
    id: 'message',
    defaultMessage: 'Message',
  },
  sendingMessage: {
    id: 'sendingMessage',
    defaultMessage: 'Sending Message',
  },
  sendMessage: {
    id: 'sendMessage',
    defaultMessage: 'Send Message'
  },
  sentMessage: {
    id: 'sentMessage',
    defaultMessage: 'Message Sent',
  },
  bulgarian: {
    id: 'bulgarian',
    defaultMessage: 'Bulgarian',
  },
  czech: {
    id: 'czech',
    defaultMessage: 'Czech',
  },
  danish: {
    id: 'danish',
    defaultMessage: 'Danish',
  },
  german: {
    id: 'german',
    defaultMessage: 'German',
  },
  greek: {
    id: 'greek',
    defaultMessage: 'Greek',
  },
  english: {
    id: 'english',
    defaultMessage: 'English',
  },
  spanish: {
    id: 'spanish',
    defaultMessage: 'Spanish',
  },
  estonian: {
    id: 'estonian',
    defaultMessage: 'Estonian',
  },
  finnish: {
    id: 'finnish',
    defaultMessage: 'Finnish',
  },
  french: {
    id: 'french',
    defaultMessage: 'French',
  },
  hebrew: {
    id: 'hebrew',
    defaultMessage: 'Hebrew',
  },
  croatian: {
    id: 'croatian',
    defaultMessage: 'Croatian',
  },
  hungarian: {
    id: 'hungarian',
    defaultMessage: 'Hungarian',
  },
  italian: {
    id: 'italian',
    defaultMessage: 'Italian',
  },
  japanese: {
    id: 'japanese',
    defaultMessage: 'Japanese',
  },
  korean: {
    id: 'korean',
    defaultMessage: 'Korean',
  },
  norwegian: {
    id: 'norwegian',
    defaultMessage: 'Norwegian',
  },
  dutch: {
    id: 'dutch',
    defaultMessage: 'Dutch',
  },
  polish: {
    id: 'polish',
    defaultMessage: 'Polish',
  },
  portuguese: {
    id: 'portuguese',
    defaultMessage: 'Portuguese',
  },
  romanian: {
    id: 'romanian',
    defaultMessage: 'Romanian',
  },
  russian: {
    id: 'russian',
    defaultMessage: 'Russian',
  },
  slovak: {
    id: 'slovak',
    defaultMessage: 'Slovak',
  },
  slovenian: {
    id: 'slovenian',
    defaultMessage: 'Slovenian',
  },
  serbian: {
    id: 'serbian',
    defaultMessage: 'Serbian',
  },
  swedish: {
    id: 'swedish',
    defaultMessage: 'Swedish',
  },
  turkish: {
    id: 'turkish',
    defaultMessage: 'Turkish',
  },
  vietnamese: {
    id: 'vietnamese',
    defaultMessage: 'Vietnamese',
  },
  chinese: {
    id: 'chinese',
    defaultMessage: 'Chinese',
  },
  howToSolveNonogram: {
    id: 'howToSolveNonogram',
    defaultMessage: 'How to Solve a Nonogram',
  },
  objective: {
    id: 'objective',
    defaultMessage: 'Objective',
  },
  nonoObjective: {
    id: 'nonoObjective',
    defaultMessage:
      `The object of the game is to fill the grid with black squares
        so that the numbers of filled sequential squares match the numbers
        at the top and left.`,
  },
  controls: {
    id: 'controls',
    defaultMessage: 'Controls',
  },
  nonoControlsLeft: {
    id: 'nonoControlsLeft',
    defaultMessage:
      'Left click to mark a square as on (black) or unknown (white).',
  },
  nonoControlsRight: {
    id: 'nonoControlsRight',
    defaultMessage:
      'Right click to mark a square as off (red X) or unknown (white).',
  },
  nonoControlsTouch: {
    id: 'nonoControlsTouch',
    defaultMessage:
      'Touch to cycle a square as on (black), off (red X), or unknown (white).',
  },
  nonoControlsDrag: {
    id: 'nonoControlsDrag',
    defaultMessage: 'Dragging works for all three of the above.',
  },
  freecell: {
    id: 'freecell',
    defaultMessage: 'Freecell',
  },
  metaDescription: {
    id: 'metaDescription',
    defaultMessage: 'Nonograms Online. Over 500,000 puzzles in 29 languages.'
  },
  metaKeywords: {
    id: 'metaKeywords',
    defaultMessage:
      'nonogram, nonograms, picture, puzzle, griddlers, griddler, picross',
  },
  mobileApps: {
    id: 'mobileApps',
    defaultMessage: 'Mobile Apps',
  },
  dailyArchive: {
    id: 'dailyArchive',
    defaultMessage: 'Archive',
  },
  day: {
    id: 'day',
    defaultMessage: 'Day',
  },
  fastestTime: {
    id: 'fastestTime',
    defaultMessage: 'Fastest Time',
  },
  name: {
    id: 'name',
    defaultMessage: 'Name',
  },
  created: {
    id: 'created',
    defaultMessage: 'Created',
  },
  markAsRead: {
    id: 'markAsRead',
    defaultMessage: 'Mark as read',
  },
  dontMissTodaysPuzzle: {
    id: 'dontMissTodaysPuzzle',
    defaultMessage: "Don't miss today's puzzle!",
  },
  playToday: {
    id: 'playToday',
    defaultMessage: 'Play Today',
  },
  dismiss: {
    id: 'dismiss',
    defaultMessage: 'Dismiss',
  },
  neverShowAgain: {
    id: 'neverShowAgain',
    defaultMessage: 'Never Show Again',
  },
  tipsAndTricks: {
    id: 'tipsAndTricks',
    defaultMessage: 'Tips and Tricks for Solving Nonograms',
  },
  startWithTheObvious: {
    id: 'startWithTheObvious',
    defaultMessage: 'Start with the obvious',
  },
  focusOnRowsOrColumns: {
    id: 'focusOnRowsOrColumns',
    defaultMessage:
      'Focus on rows or columns where the clues nearly fill the entire line.',
  },
  useBothDirections: {
    id: 'useBothDirections',
    defaultMessage: 'Use both directions',
  },
  progressInOneDirection: {
    id: 'progressInOneDirection',
    defaultMessage:
      'Progress in one direction often helps unlock logic in the other.',
  },
  markYourEmptySpaces: {
    id: 'markYourEmptySpaces',
    defaultMessage: 'Mark your empty spaces',
  },
  useARedX: {
    id: 'useARedX',
    defaultMessage: 'Use a red “X” on confirmed empty squares to stay organized.',
  },
  countCarefully: {
    id: 'countCarefully',
    defaultMessage: 'Count carefully',
  },
  separateNumbersMeanDifferentGroups: {
    id: 'separateNumbersMeanDifferentGroups',
    defaultMessage:
      'Separate numbers mean different groups with at least one space between them.',
  },
  largeNumberClues: {
    id: 'largeNumberClues',
    defaultMessage: 'Work the edges',
  },
  largeNumberCluesDescription: {
    id: 'largeNumberCluesDescription',
    defaultMessage:
      'Large number clues might only fit in limited ways—use this to your advantage.',
  },
  stayOrganized: {
    id: 'stayOrganized',
    defaultMessage: 'Stay organized',
  },
  stayOrganizedDescription: {
    id: 'stayOrganizedDescription',
    defaultMessage:
      'Scan the grid often; progress in one area may reveal clues in others.',
  },
  dontGuess: {
    id: 'dontGuess',
    defaultMessage: "Don't guess",
  },
  dontGuessDescription: {
    id: 'dontGuessDescription',
    defaultMessage: 'Stick to logic—avoid trial and error when possible.',
  },
  howToSolveNonogramDescription: {
    id: 'howToSolveNonogramDescription',
    defaultMessage:
      'Nonograms are logic-based puzzles where you fill in squares on a grid using clues provided for each row and column. These clues are numbers that tell you how many filled blocks are in that line and in what order. For instance, a clue of “4 1” means there are four filled squares followed by one filled square, with at least one blank space between the groups. Your objective is to figure out where those filled blocks go by applying logical reasoning and considering both the horizontal and vertical clues together.',
  },
  howToSolveNonogramInstructions: {
    id: 'howToSolveNonogramInstructions',
    defaultMessage:
      'To begin solving, look for rows or columns where the clues take up a large portion of the line, as those are usually easiest to fill in first. As you make progress, use what you\'ve learned to update other rows and columns. Spaces that are definitely empty should be marked with a red “X” to help avoid errors and clarify your remaining options. Gradually, by filling in confirmed squares and marking off empty ones, you\'ll work your way toward a completed and consistent grid.',
  },
  darkMode: {
    id: 'darkMode',
    defaultMessage: 'Dark Mode',
  },
  lightMode: {
    id: 'lightMode',
    defaultMessage: 'Light Mode',
  },
  todaysPuzzle: {
    id: 'todaysPuzzle',
    defaultMessage: "Today's Puzzle",
  },
  playNow: {
    id: 'playNow',
    defaultMessage: 'Play Now',
  },
  contactMessages: {
    id: 'contactMessages',
    defaultMessage: 'Messages',
  },
  dailyPuzzleArchive: {
    id: 'dailyPuzzleArchive',
    defaultMessage: 'Daily Puzzle Archive',
  },
  previous: {
    id: 'previous',
    defaultMessage: 'Previous',
  },
  next: {
    id: 'next',
    defaultMessage: 'Next',
  },
  noPuzzlesFound: {
    id: 'noPuzzlesFound',
    defaultMessage: 'No daily puzzles found for this month.',
  },
  nonogram: {
    id: 'nonogram',
    defaultMessage: 'Nonogram',
  },
};

export default messages;
